export const TX_GRID_SORT_ENABLED = 'TX_GRID_SORT_ENABLED'
export const TX_GRID_SORT_DISABLED = 'TX_GRID_SORT_DISABLED'
export const TX_GRID_SORT_REJECTED = 'TX_GRID_SORT_REJECTED'

// mapping "Column Name" => schema element real name
export const TX_GRID_SORT_ACCESS_CODE = 'transaction_identity__client_guid'
export const TX_GRID_SORT_FIRST_NAME = 'transaction_identity__first_name'
export const TX_GRID_SORT_LAST_NAME = 'transaction_identity__last_name'
export const TX_GRID_SORT_COUNTRY_CODE = 'transaction_identity__country_code'
export const TX_GRID_SORT_ACCREDITED_INVESTOR = 'transaction_identity__is_accredited_investor'
export const TX_GRID_SORT_CREATED = 'created'
export const TX_GRID_SORT_UPDATED = 'updated'
export const TX_GRID_SORT_STATUS = 'state'

export const TX_GRID_SORT_LABELS = {
  [TX_GRID_SORT_ACCESS_CODE]: 'Access Code',
  [TX_GRID_SORT_FIRST_NAME]: 'First Name',
  [TX_GRID_SORT_LAST_NAME]: 'Last Name',
  [TX_GRID_SORT_COUNTRY_CODE]: 'Country Code',
  [TX_GRID_SORT_UPDATED]: 'Updated',
  [TX_GRID_SORT_STATUS]: 'KYC/AML Status',
  [TX_GRID_SORT_ACCREDITED_INVESTOR]: 'Accredited Investor',
}

export const sortColumnLabel = (sortField) =>
  (sortField && TX_GRID_SORT_LABELS[sortField.replace(/^-/, '')]) || 'this column'

export const sortRejectionMessage = (sortField) =>
  `Sorting by ${sortColumnLabel(sortField)} needs a date range of 1 year or less.`

export const TX_GRID_SORT_ORDER_ASC = 'asc'
export const TX_GRID_SORT_ORDER_DESC = 'desc'

function enable(sortField, order) {
  return {
    type: TX_GRID_SORT_ENABLED,
    sortField,
    order,
  }
}

function disable() {
  return {
    type: TX_GRID_SORT_DISABLED,
    sortField: null,
    order: null,
  }
}

export function enableTransactionSort(sortField, order) {
  return (dispatch) => {
    dispatch(enable(sortField, order))
  }
}

export function disableTransactionSort() {
  return (dispatch) => {
    dispatch(disable())
  }
}

export function rejectTransactionSort(message) {
  return {
    type: TX_GRID_SORT_REJECTED,
    message,
  }
}
